import { createStore } from "vuex";
import user from './modules/user';
import category from './modules/category';
import banner from './modules/banner';
import product from "./modules/product";
import attributes from "./modules/attributes";
import cart from "./modules/cart";
import alert from "./modules/alert";
import ad from "./modules/ad";
import collection from "./modules/collection";
import address from "./modules/address";
import order from "./modules/order";
import store from "./modules/store";
import bannerAd from "./modules/bannerAd";
import company from "./modules/company";
import parametrization from "./modules/parametrization";
import complaint from "./modules/complaint";
import staticText from "./modules/staticText";
import token from "./modules/token";
import featured from "./modules/featured";
import signature from './modules/signature';
import productStore from './modules/productStore';
import bankData from "./modules/bankData";
import shippiments from "./modules/shippiments";

import plan from "./modules/plan";
import erp from "./modules/erp";
import box from "./modules/box";
import bling from "./modules/bling";
import payment from "./modules/payment";

export default createStore({
  modules: {
    user: user,
    category: category,
    banner: banner,
    product: product,
    cart: cart,
    plan: plan,
    erp: erp,
    attributes: attributes,
    alert: alert,
    ad: ad,
    collection: collection,
    address: address,
    order: order,
    store: store,
    bannerAd: bannerAd,
    company: company,
    parametrization: parametrization,
    bankData: bankData,
    complaint: complaint,
    staticText: staticText,
    token: token,
    featured: featured,
    signature: signature,
    productStore: productStore,
    shippiments: shippiments,
    box: box,
    bling: bling,
    payment: payment,
  }

});
